import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProjectSubmissionPrivateRoute = ({ children }) => {
  const isAuthorRole = useSelector(
    (state) => state.userSubscription.authorRole
  );
  const projectSubmission = useSelector(
    (state) => state.admin.projectSubmission
  );

  if (!isAuthorRole && !projectSubmission)
    return <Navigate to="/dashboard" />;

  return children || null;
};

export default ProjectSubmissionPrivateRoute;
